<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item name="id">
                    <a-input v-model:value="form.id" placeholder="请输入id"/>
                </a-form-item>
                <a-form-item name="type">
                    <a-input v-model:value="form.type" placeholder="请输入类型"/>
                </a-form-item>
            </div>
            <a-form-item label="实验室名称" name="name">
                <a-input v-model:value="form.name" placeholder="请输入实验室名称"/>
            </a-form-item>
            <a-row :gutter="20">
                <a-col :span="12">
                    <a-form-item label="认定时间" name="attestationTime">
                        <DatePicker v-model:value="form.attestationTime" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="级别" name="level">
                            <DictSelect
                                v-model:value="form.level"
                                :dict-name="innovation.LABORATORY_LEVEL"
                                placeholder="请选择"
                            />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-form-item label="科学领域或重点研究方向" name="researchDirection">
                <a-input v-model:value="form.researchDirection" placeholder="科学领域或重点研究方向"/>
            </a-form-item>
            <a-form-item label="合作单位，多个用逗号隔开" name="cooperationUnit">
                <a-textarea v-model:value="form.cooperationUnit" placeholder="请输入合作单位，中间用英文','隔开"
                            :auto-size="{minRows:3,maxRows:5}"/>
            </a-form-item>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="实验室场地面积(㎡)" name="area">
                        <a-input-number v-model:value="form.area" :min="0" :precision="2" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="仪器设备原值（万元）" name="price">
                        <a-input-number v-model:value="form.price" :min="0" :precision="2" style="width: 100%"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="20">
                <a-col :span="8">
                    <a-form-item label="实验室总人数" name="totalStaff">
                        <a-input-number v-model:value="form.totalStaff" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="固定人员" name="fixedsPersonnel">
                        <a-input-number v-model:value="form.fixedsPersonnel" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="流动人员" name="postdocs">
                        <a-input-number v-model:value="form.postdocs" :min="0" :precision="0" style="width: 100%" />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-divider orientation="left">固定人员结构</a-divider>
            <a-row :gutter="20">

                <a-col :span="8">
                    <a-form-item label="正高级人数" name="senior">
                        <a-input-number v-model:value="form.senior" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="副高级人数" name="subSenior">
                        <a-input-number v-model:value="form.subSenior" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="中级人数" name="middle">
                        <a-input-number v-model:value="form.middle" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="博士人数" name="doctor">
                        <a-input-number v-model:value="form.doctor" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="硕士人数" name="master">
                        <a-input-number v-model:value="form.master" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="学士人数" name="bachelor">
                        <a-input-number v-model:value="form.bachelor" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-divider orientation="left">实验室负责人</a-divider>
            <a-row :gutter="20">
                <a-col :span="8">
                    <a-form-item label="姓名" name="headName">
                        <a-input v-model:value="form.headName" placeholder="请输入姓名"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="出生日期" name="headBirthday">
                        <DatePicker v-model:value="form.headBirthday" placeholder="请输入出生日期" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="最后学历" name="headEducation">
                        <a-input v-model:value="form.headEducation" placeholder="请输入最后学历"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="职称" name="headTitle">
                        <a-input v-model:value="form.headTitle" placeholder="请输入职称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="职务" name="headPost">
                        <a-input v-model:value="form.headPost" placeholder="请输入职务"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="从事专业" name="headMajor">
                        <a-input v-model:value="form.headMajor" placeholder="请输入从事专业"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="电话" name="headPhone">
                        <a-input v-model:value="form.headPhone" placeholder="请输入电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="工作单位" name="headCompany">
                        <a-input v-model:value="form.headCompany" placeholder="请输入工作单位"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-divider orientation="left">学术委员会主任</a-divider>
            <a-row :gutter="20">
                <a-col :span="8">
                    <a-form-item label="姓名" name="directorName">
                        <a-input v-model:value="form.directorName" placeholder="请输入姓名"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="出生日期" name="directorBirthday">
                        <DatePicker v-model:value="form.directorBirthday" placeholder="请输入出生日期" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="最后学历" name="directorEducation">
                        <a-input v-model:value="form.directorEducation" placeholder="请输入最后学历"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="职称" name="directorTitle">
                        <a-input v-model:value="form.directorTitle" placeholder="请输入职称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="职务" name="directorPost">
                        <a-input v-model:value="form.directorPost" placeholder="请输入职务"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="从事专业" name="directorMajor">
                        <a-input v-model:value="form.directorMajor" placeholder="请输入从事专业"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="电话" name="directorPhone">
                        <a-input v-model:value="form.directorPhone" placeholder="请输入电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="工作单位" name="directorCompany">
                        <a-input v-model:value="form.directorCompany" placeholder="请输入工作单位"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-form-item label="实验室简介" name="profile">
                <a-textarea v-model:value="form.profile" placeholder="请输入实验室简介" :auto-size="{minRows:3,maxRows:5}"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import {formMixin} from "@/mixins";
import dataCheck from "@/utils/dataCheck";
import {ScientificApi} from "@/api/innovationService";
import {companyOriginInfo} from "@/api/tenantService";
import {innovation} from "@/config/variableConfig"
import DictSelect from "@/components/other/DictSelect";
import DatePicker from "@/components/form/datePicker/DatePicker";

export default {
    name: "addOrEditModal",
    mixins: [formMixin],
    components: {DictSelect,DatePicker},
    data() {
        return {
            options:[],
            innovation,
            /*表单绑定值与验证规则定义*/
            form: {
                id: null,
                area: null,
                bachelor: null,
                cooperationUnit: null,
                directorBirthday: null,
                directorEducation: null,
                directorMajor: null,
                directorName: null,
                directorPhone: null,
                directorPost: null,
                directorTitle: null,
                directorCompany: null,
                doctor: null,
                fixedsPersonnel: null,
                headBirthday: null,
                headCompany: null,
                headEducation: null,
                headMajor: null,
                headName: null,
                headPhone: null,
                headPost: null,
                headTitle: null,
                level: null,
                master: null,
                middle: null,
                name: null,
                postdocs: null,
                price: null,
                profile: null,
                researchDirection: null,
                subSenior: null,
                attestationTime: null,
                totalStaff: null,
                type: null,
                senior: null,
            },
            rules: {
                id:[],
                area: [],
                bachelor: [],
                cooperationUnit: [],
                directorBirthday: [],
                directorEducation: [],
                directorMajor: [],
                directorName: [],
                directorPhone: [dataCheck.mobile_phone],
                directorPost: [],
                directorTitle: [],
                directorCompany: [],
                doctor: [],
                fixedsPersonnel: [],
                headBirthday: [],
                headCompany: [],
                headEducation: [],
                headMajor: [],
                headName: [],
                headPhone: [dataCheck.mobile_phone],
                headPost: [],
                headTitle: [],
                level: [],
                master: [],
                middle: [],
                name: [],
                postdocs: [],
                price: [],
                profile: [],
                researchDirection: [],
                subSenior: [],
                attestationTime: [],
                totalStaff: [],
                senior: [],
                type: [],
            },
            /*提交表单地址*/
            submitUrl: ScientificApi.saveOrUpdate
        }
    },
    mounted() {
        this.getCompany()
    },
    methods: {
        filterOption(input, option) {
            return (
                option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        getCompany() {
            this.getAction({
                url: companyOriginInfo.List
            }).then(res => {
                this.options = res
            })
        }
    },
}
</script>
<style scoped lang="less">

</style>
